
class AndroidAppSpecification {
	bundleIdentifier = null;
	minimumSupportedVersion = null;
	latestVersion = null;
	downloadUrl = null;
}


export { AndroidAppSpecification };
